export default "__VITE_ASSET__apMIHmwd__"